import { Taxon } from "./IBMR-taxon";

export class Transect {

    id: number; // For IndexedDB
    mesureId: number;

    LpB: number;
    Lm: number;

    TaxonList: Taxon[] = []

    static mapFromJSON(json): Transect {
        const l = new Transect();

        l.LpB = json.lpb;
        l.Lm = json.lm;

        if (json.taxonList) {
            l.TaxonList = json.taxonList.map(jsonItem => Taxon.mapFromJSON(jsonItem));
        }

        return l;
    }
}
